// extracted by mini-css-extract-plugin
module.exports = {"root":"DraftInfoWithActions_root__2488E","actions":"DraftInfoWithActions_actions__1upRM","col":"DraftInfoWithActions_col__1wCJk"};